export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
export const USER_POOL_CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID;
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
export const REDIRECT_SIGNIN_URL = process.env.REACT_APP_REDIRECT_SIGNIN;
export const REDIRECT_SIGNOUT_URL = process.env.REACT_APP_REDIRECT_SIGNOUT;
export const SELF_SERVICE_ADMIN_URL = process.env.REACT_APP_SELF_SERVICE_ADMIN_URL;
export const PREMIUM_COLLECTION_ADMIN_URL =
  process.env.REACT_APP_PREMIUM_COLLECTION_ADMIN_URL;
export const IPAS_ADMIN_URL = process.env.REACT_APP_IPAS_ADMIN_URL;
export const WORKSPACE_PORTAL_URL = process.env.REACT_APP_WORKSPACE_PORTAL_URL;
/**
 * The IFAS portal's origin, e.g. https://ifas.staging.icebolethu.co.za. IFAS
 * moved out of this app (#2089); IFAS accounts and ?portal=ifas logins are sent
 * there. Unset where IFAS is not live, which turns the redirect into a notice.
 */
export const IFAS_PORTAL_URL = process.env.REACT_APP_IFAS_PORTAL_URL;
export const COMPLIANCE_ADMIN_URL = process.env.REACT_APP_COMPLIANCE_ADMIN_URL;
